import { render, staticRenderFns } from "./searchClient.vue?vue&type=template&id=827bd43a&scoped=true"
import script from "./searchClient.vue?vue&type=script&lang=js"
export * from "./searchClient.vue?vue&type=script&lang=js"
import style0 from "./searchClient.vue?vue&type=style&index=0&id=827bd43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827bd43a",
  null
  
)

export default component.exports